import thumosHero from '../img/portfolio/thumos-og.png';

export const works = [
  {
    id: 1,
    src: [thumosHero],
    desc: 'Systems, doctrine, and operational intelligence — we build systems that move the world, from human experience to resilient infrastructure.',
    title: 'MetaMotion LLC',
    date: '2024',
    category: 'Systems & Doctrine',
    link: 'https://www.metamotionhq.com',
    technologies: 'OilCheck, Axiom Standard, Thumos, Infrastructure Doctrine, Operational Systems, Experience Architecture',
    technologyLinks: {
      OilCheck: 'https://www.metamotionhq.com/products/oilcheck',
      'Axiom Standard': 'https://www.metamotionhq.com/products/axiom-standard',
      Thumos: 'https://www.metamotionhq.com/products/thumos'
    },
    flagshipTech: 'Thumos'
  }
];
